module.exports = __webpack_public_path__ + "static/media/usa_map.ef6fdb95.svg";